import { useCallback, useEffect } from "react";
import useAppModernisation from "../useAppModernisation";

const useContentOverflow = (ref) => {
  const { isModernView } = useAppModernisation();

  const createSwipeIndicator = useCallback(() => {
    const indicator = document.createElement("div");
    indicator.className = "indicator";
    indicator.textContent = "Swipe to see more";

    const swipeIcon = document.createElement("i");
    swipeIcon.classList.add("tg-icons-DoubleArrowRight");

    indicator.appendChild(swipeIcon);
    return indicator;
  }, []);

  const wrapOverflowingTable = useCallback((table) => {
    const parent = table.parentElement;
    if (!parent || parent.classList.contains("enableOverflow")) return;

    const { right } = table.getBoundingClientRect();
    const isOverflowing = right > window.innerWidth;

    if (isOverflowing) {
      const indicator = createSwipeIndicator();
      parent.insertBefore(indicator, table);

      const wrapper = document.createElement("div");
      wrapper.className = "enableOverflow";
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }, []);

  const checkContentOverflow = useCallback(
    (root) => {
      if (!isModernView || !root) return;
      const tables = root.querySelectorAll("table");
      tables.forEach(wrapOverflowingTable);
    },
    [isModernView, wrapOverflowingTable],
  );

  useEffect(() => {
    if (ref?.current) {
      checkContentOverflow(ref.current);
    }
  }, [ref, checkContentOverflow]);

  return { checkContentOverflow };
};

export default useContentOverflow;